export function isTouchDevice() {
  if (typeof window === 'undefined') return false;
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    window.matchMedia('(pointer: coarse)').matches
  );
}

const MOBILE_WARN_KEY = 'ct_mobile_warning_seen';

export function shouldShowMobileWarning() {
  if (!isTouchDevice()) return false;
  return !localStorage.getItem(MOBILE_WARN_KEY);
}

export function markMobileWarningSeen() {
  localStorage.setItem(MOBILE_WARN_KEY, '1');
}
